
<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: wuzhen wz0309@163.com
 * @LastEditTime: 2024-01-31 15:09:30
 * @Description: 日行一善s
-->
<template>
  <div style="background: rgb(246, 248, 251);height: 100vh;width: 100%;">
      <el-container>
        <el-aside width="180px">
          <el-tabs tab-position="left" style="height: 100%;" @tab-click="change_tab" v-model="tabActive">
            <el-tab-pane label="全部消息" name="0"> </el-tab-pane>
            <el-tab-pane label="已读消息" name="1"> </el-tab-pane>
            <el-tab-pane label="未读消息" name="2"> </el-tab-pane>
          </el-tabs>
        </el-aside>
        <el-main class="mainContent" style="height: 100vh;">
          <div>
            <el-breadcrumb separator="/" style="margin-top: 10px;">
              <el-breadcrumb-item v-for="item,index in tabRlact[tabActive]" :key="index">{{ item }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="border-bottom: 2px solid rgb(246, 248, 253);width: 100%;margin: 10px 0;"></div>
            <div v-if="tabActive == '0'">
              <AllMessage/>
            </div>
            <div v-if="tabActive == '1'">
              <ReadMessage/>
            </div>
            <div v-if="tabActive == '2'">
              <UnreadMessage/>
            </div>
          </div>
        </el-main>
      </el-container>
  </div>
</template>

<script>
import AllMessage from "@/components/MessageModule/AllMessage";
import ReadMessage from "@/components/MessageModule/ReadMessage";
import UnreadMessage from "@/components/MessageModule/UnreadMessage"
export default {
  name: "Message",
  components: { AllMessage,ReadMessage, UnreadMessage },
  data() {
    return {
      tabRlact:{
        '0':['站内通知','全部消息'],
        '1':['站内通知','已读消息'],
        '2':['站内通知','未读消息'],
      },
      tabActive:'0'
    };
  },
  methods: {
    change_tab(val) {
      this.tabActive = val.name
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.middle {
  vertical-align: middle;
  /* height: 31px; */
  width: 126px;
  height: 50px;
}
.mainContent {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue